<script>
import fileViewer from "@/components/file-viewer.vue";
import detailView from "@/components/detail-view.vue";
import {downLoadFile, getSuffix} from "@/common/js/tool";
import {applyStage, getApplyStatusText} from "../../common/constant/apply";
import {getShowFileList} from "@/common/js/file";
export default {
  name: "ApprovalDetail",
  components: {
    fileViewer,
    detailView
  },
  data() {
    return {
      info: null,
      current: null,
      colors: ['#3f6fb8', '#52c41a', '#e60012'],
      visible: false,
      status: 1,
      form: {},
      loading: false,
    }
  },
  computed: {
    items() {
      const res = [
        {
          key: 'files',
          label: '附件',
          component: 'file-upload',
          props: {
            limit: -1
          },
        },
      ]
      const status = this.status;
      if (status === 1) {
        res.unshift({
          key: 'note',
          label: '备注',
          component: 'a-textarea',
          props: {
            placeholder: '请输入',
            rows: 4
          },
        })
      } else {
        res.unshift({
          key: 'note',
          label: '驳回原因',
          component: 'a-textarea',
          props: {
            placeholder: '请输入',
            rows: 4
          },
          rules: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }]
        })
      }
      return res;
    }
  },
  created() {
    this.getApplyDetail();
  },
  methods: {
    getApplyStatusText,
    cancel() {
      this.visible = false;
    },
    confirm(form) {
      if(this.loading) return;
      this.loading = true;
      const info = this.info;
      const item = {
        time: new Date().pattern("yyyy-MM-dd HH:mm:ss"),
        status: this.status,
        note: form.note,
        files: form.files,
        stage: this.current.stage
      };
      const flow = this.info.flow;
      const data = {
        flow_detail: JSON.stringify([...flow, item]),
      }
      // 节点驳回 将整个审批状态变成已驳回
      if (this.status === 2) {
        data.status = 5;
      }
      // 节点通过并且是最后一个节点 将整个审批状态变成已通过
      else if(this.current.stage === applyStage[applyStage.length - 1].key) {
        data.status = 4;
      }
      this.$axios({
        url: `/admin/apply/${info.id}`,
        method: "PATCH",
        data
      }).then(res => {
        this.dealApply({...info, ...res});
        this.visible = false;
      }).finally(() => this.loading = false);
    },
    showModal(status) {
      this.form = {};
      this.status = status;
      this.visible = true;
    },
    downLoad() {
      const info = this.info;
      if (info.img) {
        downLoadFile(info.img, `${info.chinese_name}${getSuffix(info.img)}`);
      }
    },
    getApplyDetail() {
      const id = this.$route.params.id;
      if(!id) return;
      this.$axios.get(`/admin/apply/${id}?expand=user`).then(this.dealApply)
    },
    dealApply(info) {
      let flow = info.flow_detail;
      if(flow) {
        try {
          flow = JSON.parse(flow);
        } catch (e) {
          console.error(e);
          flow = [];
        }
      } else {
        flow = [];
      }
      info.flow = flow;
      info.flowList = applyStage.map(item => {
        const s = {
          stage: item.key,
          title: item.title,
          loadingText: item.loadingText,
          confirmText: item.confirmText
        };
        const f = flow.find(p => p.stage === s.stage);
        if(f) {
          s.status = f.status;
          s.time = f.time;
          s.detailList = [
            {label: f.status === 1 ? '备注' : '驳回原因', value: f.note, full: true},
            {label: '附件', value: getShowFileList(f.files), file: true, full: true},
          ]
        }
        return s;
      });
      // 审批中 计算当前审批的节点
      if(info.status === 3) {
        // 当前进行的阶段
        const current = info.flowList.find(f => !f.status);
        this.current = current || null;
      } else {
        this.current = null;
      }
      const ap = {
        stage: 0,
        title: '申请',
        status: 1,
        confirmText: '提交申请'
      }
      const f = flow.find(p => p.stage === ap.stage);
      if(f) {
        ap.time = f.time;
      } else {
        ap.time = info.create_time;
      }
      info.flowList.unshift(ap)
      this.info = info;
    },
  }
}
</script>

<template>
<div class="content flex-box">
  <div class="apply-piece">
    <div class="apply-piece-title">
      <div class="piece-title-text">信息预览</div>
      <a-button type="primary" icon="download" @click="downLoad">下载文件</a-button>
    </div>
    <div class="apply-piece-content">
      <file-viewer :url="info.img" v-if="info"></file-viewer>
    </div>
  </div>
  <div class="apply-piece apply-progress">
    <div class="apply-piece-title">
      <div class="piece-title-text">审批流程</div>
      <a-tag :color="colors[info.status - 3]" v-if="info">{{ getApplyStatusText(info.status) }}</a-tag>
    </div>
    <div class="apply-piece-content">
      <a-timeline v-if="info">
        <a-timeline-item :color="colors[f.status || 0]" v-for="f in info.flowList" :key="f.stage">
          <div class="apply-process-top">
            <div class="apply-process-title">{{ f.title }}</div>
            <div class="apply-process-state" v-if="f.status === 1">{{ f.time }} {{ f.confirmText}}</div>
            <div class="apply-process-state" v-else-if="current && current.stage === f.stage">{{ f.loadingText }}</div>
          </div>
          <div class="apply-process-info" v-if="f.status > 0">
            <div class="apply-process-user" v-if="f.stage === 0">手机号:{{ info.user ? info.user.mobile : "--" }}</div>
            <detail-view :list="f.detailList" style="width: 400px"></detail-view>
          </div>
          <a-space class="apply-process-operate" v-if="current && current.stage === f.stage">
            <a-button @click="showModal(2)">驳回</a-button>
            <a-button type="primary" @click="showModal(1)">通过</a-button>
          </a-space>
        </a-timeline-item>
      </a-timeline>
    </div>
  </div>
  <a-modal
    :title="`${current ? current.title : ''}${status === 1 ? '通过' : '驳回'}`"
    :width="640"
    :footer="null"
    :body-style="{padding: 0}"
    v-model="visible">
    <form-area
      ref="adminForm"
      class="flex-box vertical"
      layout="horizontal"
      :label-col="{span: 4}"
      :wrapper-col="{span: 20}"
      :items="items"
      :entity="form"
      confirm-text="确定"
      @cancel="cancel()"
      @confirm="confirm"></form-area>
  </a-modal>
</div>
</template>

<style scoped lang="less">
.apply-piece {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.apply-progress {
  margin-left: 48px;
  .apply-piece-title {
    justify-content: flex-start;
  }
  .piece-title-text {
    margin-right: 16px;
  }
  .apply-piece-content {
    padding: 24px;
  }
}
.apply-piece-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  font-size: 18px;
}
.apply-piece-content {
  flex: 1;
  min-height: 0;
}
.apply-process-top {
  display: flex;
  align-items: center;
}
.apply-process-title {
  width: 200px;
  font-size: 16px;
}
.apply-process-state {
  color: @text-color-secondary;
}
.apply-process-info,
.apply-process-operate {
  margin: 24px 0 12px;
}
.apply-process-operate {
  justify-content: flex-end;
  width: 400px;
}
</style>